import axios from "axios";
import Unit from "@/src/utils/constants/units";

export const getEndeksaDemographicSectionInfos = async (listingID) => {
  const url = `${process.env.EJ_APPS_API_HOSTNAME}/e6t/v1/endeksa/demographic-info-for-listing/${listingID}`;
  const response = await axios.get(url, {
    validateStatus: (status) => {
      return true;
    },
  });
  return response.data;
};

export const getEndeksaDemographicSectionInfosForProject = async (projectSlug) => {
  const url = `${process.env.EJ_APPS_API_HOSTNAME}/e6t/v1/endeksa/demographic-info-for-project/${projectSlug}`;
  const response = await axios.get(url, {
    validateStatus: (status) => {
      return true;
    },
  });
  return response.data;
};

export const getEndeksaPriceSectionInfos = async (listingID, tradeType = "SALE", priceType = "PRICE") => {
  const targetPriceType = priceType === Unit.M2.name ? "M2" : priceType;
  const apiUrl = typeof window !== "undefined" ? window.env.EJ_APPS_API_HOSTNAME : process.env.EJ_APPS_API_HOSTNAME;
  const url = `${apiUrl}/e6t/v1/endeksa/region-price-info-for-listing/${listingID}?priceType=${targetPriceType}&tradeType=${tradeType}`;
  const response = await axios.get(url, {
    validateStatus: (status) => {
      return true;
    },
  });
  return response.data;
};

export const getEndeksaPriceSectionInfosForProject = async (projectSlug, roomCount, priceType = "PRICE") => {
  const apiUrl = typeof window !== "undefined" ? window.env.EJ_APPS_API_HOSTNAME : process.env.EJ_APPS_API_HOSTNAME;
  const url = `${apiUrl}/e6t/v1/endeksa/region-price-info-for-project/${projectSlug}?priceType=${priceType}&roomCount=${roomCount}`;
  const response = await axios.get(url, {
    validateStatus: (status) => {
      return true;
    },
  });
  return response.data;
};
